import { render, staticRenderFns } from "./CertsTableView.vue?vue&type=template&id=c102a872"
import script from "./CertsTableView.vue?vue&type=script&lang=js"
export * from "./CertsTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c102a872')) {
      api.createRecord('c102a872', component.options)
    } else {
      api.reload('c102a872', component.options)
    }
    module.hot.accept("./CertsTableView.vue?vue&type=template&id=c102a872", function () {
      api.rerender('c102a872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/certificados/CertsTableView.vue"
export default component.exports